<template>
    <div>
        <div class="row justify-content-sm-center text-center mt-2 py-1 mr-0 ml-0">
            <div class="col-sm-3 text-left align-self-center">
                <label class="d-block text-secondary text-left mb-0">Veselības pārbaudes veids</label>
                <b-form-select id="period" class="w-100 py-1 ds-input" v-model="selectedHeathChechType"
                    :options="healthChechTypeOptions" />
            </div>


            <div class="col-sm-2 align-self-center" v-if="selectedHeathChechType === 2">
                <ValidationProvider tag="div" class="mb-0" vid="health-check" mode="lazy"
                    :customMessages="{ required: 'Norādi ārpuskārtas pārbaudes veidu!' }" rules="required"
                    v-slot="{ errors }">
                    <label class="d-block text-secondary text-left mb-0">Iemesls</label>
                    <input type="text" id="health" class="w-100 py-1 ds-input" v-model="specificHeathChech">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="col-sm-2" v-else></div>
        </div>
        <b-form-checkbox-group v-model="selectedOvps" name="user-ovp" ref="user-ovp">
            <div class="row text-center my-4 mr-0 ml-0">
                <div class="col-sm-1 font-weight-bold text-left"></div>
                <div class="col-sm-6 font-weight-bold text-left">Darba apstāklis</div>
                <div class="col-sm-1 font-weight-bold text-left">Periods</div>
                <div class="col-sm-1 font-weight-bold text-center">Īpašs</div>
                <div class="col-sm-1 font-weight-bold text-center">Gaida apstiprinājumu</div>
                <div class="col-sm-2 font-weight-bold text-right">Beigu termiņš</div>
            </div>
            <div class="row text-center mt-2 mr-0 ml-0" v-for="ovpJobCondition in item.ovpJobConditions"
                :key="ovpJobCondition._id">
                <div class="col-sm-1 pr-0 mr-0 text-right align-self-center">
                    <b-form-checkbox :id="ovpJobCondition._id" :value="ovpJobCondition.formatedDocData"
                        :disabled="ovpJobCondition.waitingForApproval" class="green-checkbox mr-0"></b-form-checkbox>
                </div>
                <div class="col-sm-6 text-left align-self-center">
                    <label :for="ovpJobCondition._id">{{ ovpJobCondition.ovpJobCondition.globalOvpJobCondition.name
                        }}</label>
                    <font-awesome-icon size="lg" v-if="ovpJobCondition.doctorsComment" v-b-tooltip.hover.viewport
                        :title="ovpJobCondition.doctorsComment" icon="comment-medical" class="ml-2" />
                </div>
                <div class="col-sm-1 text-left align-self-center">{{ ovpJobCondition.formatedPeriod }}</div>
                <div class="col-sm-1 text-center align-self-center">
                    <font-awesome-icon v-if="ovpJobCondition.ovpJobCondition.isSpecial" icon="toggle-on" class="mr-1" />
                    <font-awesome-icon v-else icon="toggle-off" class="mr-1" />
                </div>
                <div class="col-sm-1 text-center align-self-center">
                    <font-awesome-icon v-if="ovpJobCondition.waitingForApproval" icon="toggle-on" class="mr-1" />
                    <font-awesome-icon v-else icon="toggle-off" class="mr-1" />
                </div>
                <div class="col-sm-2 text-right align-self-center">{{ ovpJobCondition.nextInspectionDate }}</div>
            </div>
        </b-form-checkbox-group>
    </div>
</template>
<script>
import { mapMutations } from 'vuex';
import { extend, ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import * as ovpStoreTypes from '../../../vuex/modules/ovp/ovp.store-types';

export default {
    name: 'user-ovp-list',
    components: { ValidationProvider },
    props: {
        item: {
            required: true,
        }
    },
    data: () => ({
        selectedOvps: [],
        healthChechTypeOptions: [{ text: 'Pirmreizējā', value: 1 }, { text: 'Ārpuskārtas', value: 2 }, { text: 'Periodiskā', value: 3, selected: true }],
        specificHeathChech: '',
        selectedHeathChechType: 3,
    }),
    async created() {
        extend('required', required);
        this.selectedOvps = this.item.ovpJobConditions.filter(ovpJobCondition => {
            const [day, month, year] = ovpJobCondition.nextInspectionDate.split('.')
            const differenceInYears = new Date((new Date(year, month, day))- new Date()).getFullYear() - 1970 
              return !ovpJobCondition.waitingForApproval 
                    && differenceInYears <= 0
        }).map(({ formatedDocData }) => formatedDocData)
    },
    watch: {
        selectedOvps(newValue, oldValue) {
            if (oldValue.length !== newValue.length &&
                 newValue.length == 0) {
                this.$emit('unselectedOvps')
            }
        },
        userData(selectedUser) {
            if (!selectedUser.userData.ovpJobConditions.length && !selectedUser.userData.specialOvpJobConditions.length) {
                return;
            }

            return this.setSelectedUsers(selectedUser);
        },
    },
    computed: {
        regularOvpsWithOneYearPeriod() {
            return this.item.ovpJobConditions
                .filter(({ ovpJobCondition, waitingForApproval }) => +ovpJobCondition.period === 1 && !ovpJobCondition.isSpecial && !waitingForApproval)
                .map(({ formatedDocData }) => formatedDocData);
        },
        specialOvpsWithOneYearPeriod() {
            return this.item.ovpJobConditions
                .filter(({ ovpJobCondition, waitingForApproval }) => +ovpJobCondition.period === 1 && ovpJobCondition.isSpecial && !waitingForApproval)
                .map(({ formatedDocData }) => formatedDocData);
        },
        selectedRegularOvps() {
            return this.selectedOvps.filter(({ isSpecial }) => !isSpecial)
        },
        selectedSpecialOvps() {
            return this.selectedOvps.filter(({ isSpecial }) => isSpecial)
        },
        selectedHeathChech() {
            return this.selectedHeathChechType === 2 ? this.specificHeathChech : this.selectedHeathChechType;
        },
        userData() {
            return {
                userId: this.item._id,
                userData: {
                    userId: this.item._id,
                    name: this.item.name,
                    surname: this.item.surname,
                    jobTitle: this.item.jobTitleIdentifier?.name,
                    specialOvpJobConditions: this.selectedSpecialOvps,
                    ovpJobConditions: this.selectedRegularOvps,
                    healthCheck: this.selectedHeathChech,
                }
            }
        },
    },
    methods: {
        ...mapMutations('ovp', {
                /** @type {function|*} */
                setSelectedUsers: ovpStoreTypes.SET_SELECTED_OVP_USERS,
            })
    },
}
</script>